module.exports = __webpack_public_path__ + "img/apple6.0f3ac1db.png";